import { render, staticRenderFns } from "./ProvisionPSDU.vue?vue&type=template&id=31fdf7b8"
import script from "./ProvisionPSDU.vue?vue&type=script&lang=js"
export * from "./ProvisionPSDU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports